import { baseApiPath, get, patch } from "./base-api";
import {
  IGetSettingsResponse,
  ICrmSettings,
  IAutoBidSettings,
} from "../data-access";

const getSettings = (): Promise<IGetSettingsResponse> => {
  return get<IGetSettingsResponse>(`${baseApiPath}/api/settings`);
};

const updateSettings = (
  settings: ICrmSettings
): Promise<IGetSettingsResponse> => {
  return patch<ICrmSettings, IGetSettingsResponse>(
    `${baseApiPath}/api/settings/crm`,
    settings
  );
};

const updateAutoBidSettings = (
  settings: Partial<IAutoBidSettings>
): Promise<IGetSettingsResponse> => {
  return patch<Partial<IAutoBidSettings>, IGetSettingsResponse>(
    `${baseApiPath}/api/settings/autobid`,
    settings
  );
};

export const settingsApi = {
  getSettings,
  updateSettings,
  updateAutoBidSettings,
};
